import React from 'react';
import { Link } from 'react-router-dom'; // Assuming you're using react-router

const Breadcrumbs = ({ crumbs }) => {
  if (!crumbs.length) {
    return null;
  }

  return (
    <div>
      <nav className='flex' aria-label='Breadcrumb'>
        <ol className='inline-flex items-center space-x-1'>
          {crumbs.map((crumb, i) => {
            const isLast = i === crumbs.length - 1;

            return (
              <li key={i} className='inline-flex items-center'>
                {!isLast ? (
                  <Link
                    to={crumb.path}
                    className='inline-flex items-center text-sm font-medium text-black-700 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white'
                  >
                    {crumb.breadcrumb}
                    <svg className='w-4 h-4 mx-2' fill='currentColor' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'>
                      <path d='M5.5 10a.5.5 0 01.5-.5h8a.5.5 0 010 1h-8a.5.5 0 01-.5-.5z'></path>
                    </svg>
                  </Link>
                ) : (
                  <span className='text-sm font-medium text-black-400 md:text-black-500 dark:text-black-400'>{crumb.breadcrumb}</span>
                )}
              </li>
            );
          })}
        </ol>
      </nav>
    </div>
  );
};

export default Breadcrumbs;
